import React from 'react'
import classNames from 'classnames'
import HorizontalLine from 'src/components/Elements/HorizontalLine'
import Button from 'src/components/Elements/Button'
import ExpandableDiv from 'src/components/Elements/ExpandableDiv'
import fontStyles from 'src/assets/styles/fontStyles.module.scss'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'
import programStyles from '../programStyles.module.scss'

const LocationBlock = ({
  block,
  venueName,
  venueUrl,
  mapUrl,
  venueInfo,
  reservationUrl,
  reducedConferenceRateCode,
  reservationsPhone,
  currencyTypeDropdownOptionalValue,
  currencyTypeDropdownOptionalValue2,
  reservationDeadlineDate,
  eventDiscountedRate,
  showBlurb
}) => {
  const renderMap = () => {
    const adjustedMap = mapUrl.replace(
      'iframe src',
      'iframe width="100%" height="300" src'
    )
    return (
      <div
        data-testid='locationMap'
        dangerouslySetInnerHTML={{
          __html: `
        <!DOCTYPE html>
        <html>
          <head></head>
          <body style="background: #EFEFF0; width: 100%">
            <div id="baseDiv">${adjustedMap}</div>
          </body>
        </html>
  `
        }}
      ></div>
    )
  }
  const renderInfo = () => {
    if (venueInfo !== null) {
      return (
        <ExpandableDiv
          toggleableDiv={
            <div
              className={classNames(
                generalStyles.pt20,
                generalStyles.pl20,
                generalStyles.pr20,
                fontStyles.psmalllsblackgraphik15pt
              )}
              dangerouslySetInnerHTML={{ __html: venueInfo }}
            />
          }
          unexpandedText={'View More Information'}
          expandedText={'View Less Information'}
          testID={'ViewInfo'}
        />
      )
    }
  }
  const renderResInfo = () => {
    if (showBlurb) {
      return (
        <div
          className={classNames(
            generalStyles.pb20,
            generalStyles.pl20,
            generalStyles.pr20,
            fontStyles.psmalllsblackgraphik15pt
          )}
          data-testid='resInfo'
        >
          <div data-testid='resInfoBody'/>
          <p>A block of rooms has been reserved at the {venueName} at a reduced conference rate.
            Reservations should be made <a href={reservationUrl} rel='noreferrer' target='_blank'><span className={fontStyles.fontWeight500}>online</span></a> or by calling {reservationsPhone}.
            Please mention {reducedConferenceRateCode} to ensure the appropriate room rate.</p>
          <p>Deadline to book using the discounted room rate of {currencyTypeDropdownOptionalValue}{eventDiscountedRate} {currencyTypeDropdownOptionalValue2} (plus tax) is <span className={fontStyles.fontWeight500}>{reservationDeadlineDate}</span>.</p>
          <div className={generalStyles.flexCentered} data-testid='resInfoButton'>
            <Button
              color={'lightBase'}
              onClick={() => window.open(reservationUrl)}
              label={'Reserve a Room'}
              size={'small'}
            />
          </div>
        </div>
      )
    }
  }

  return (
    <div key={block?.id} className={programStyles.locationBlockContainer}>
      <div className={programStyles.header} data-testid='locationHeader'>
        <span className={fontStyles.h5lsgraphik20pt} data-testid='locationTitle'>{block?.title}</span>
        <div className={classNames(generalStyles.mt10, generalStyles.mb20)}>
          <HorizontalLine color={'white'} fullWidth={true} />
        </div>
        <a
          className={fontStyles.psmallboldlsin01lightbasegraphik15pt}
          href={venueUrl}
          target="_blank"
          rel="noreferrer"
          data-testid="venueName"
        >
          {venueName}
        </a>
      </div>
      {renderMap()}
      {renderInfo()}
      {renderResInfo()}
    </div>
  )
}

export default LocationBlock
